import {useEffect, useState} from 'react'
import {toggle} from 'opticks'

import {useDispatchTeamEvent} from '@daedalus/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'

export const TrackUserAgentChange = () => {
  const [initialUA, setInitialUA] = useState(null)
  const dispatchTeamEvent = useDispatchTeamEvent()
  const isFeatureFlagEnabled = toggle(
    'feature-track-user-agent-change',
    false,
    true
  )

  useEffect(() => {
    setInitialUA(navigator.userAgent)
  }, [])

  useEffect(() => {
    const checkUA = () => {
      if (
        initialUA !== null &&
        navigator.userAgent !== initialUA &&
        isFeatureFlagEnabled
      ) {
        new Promise(resolve => {
          dispatchTeamEvent(
            trackEvent({
              category: Category.System,
              entity: Entity.UserAgent,
              action: Action.Changed,
              payload: {
                newUserAgent: navigator.userAgent,
                oldUserAgent: initialUA
              }
            })
          )
          setTimeout(() => {
            resolve(true)
            // wait for the event to be dispatched
          }, 300)
        }).then(() => {
          window.location.reload()
        })
      }
    }

    if (isFeatureFlagEnabled) {
      window.addEventListener('click', checkUA)
      window.addEventListener('scroll', checkUA)
      window.addEventListener('resize', checkUA)
    }

    return () => {
      window.removeEventListener('click', checkUA)
      window.removeEventListener('scroll', checkUA)
      window.removeEventListener('resize', checkUA)
    }
  }, [dispatchTeamEvent, initialUA, isFeatureFlagEnabled])

  return null
}
